import React, { Fragment,useRef } from "react";
import PostApiData from "../api/PostApiData";
import PostHistoryData from "../api/PostHistoryData";
import SetManageDoc from "../api/SetManageDoc";
import Disagreement from "../constants/disagreement.json";
import BrtxCardModal from "./BrtxCardModal";
import LookUpData from "./lookUpData";

class Unpacking extends React.Component {
  ref = null;
  timer = null;
  state = {
    selectedActualApiData: -1,
    value: "",
    scanShow: false,
    disagreement: Disagreement,
    docno: {
      DocNo: -1,
      DeviceFirmCode: null,
      FirmName: null,
      DeviceType: null,
      DeviceRepairType: null,
      DeviceRepairPrice: null,
      InRepType: null,
      DeviceReseller: null,
      DeviceSN: null,
      NumAtCard: null,
      StavPristroje: null,
      CisPoj: null,
      PrioritaZprac: null,
      Prislus: null,
      PrislusOth: null,
      ProductCodeSN: null,
      DeviceDefectDescEx: null,
      DatProdej: null,
      DatExtPr: null,
      BattYN: 0,
      BattSN: null,
      SAM_SWCust: null,
      SAM_CustType: null,
      SAM_DatVyr: null,
      OTA: null,
      SAM_SAW: null,
      SAM_DuvodOTA: null,
      SAM_DatAct: null,
      SAM_RepairRepeated: null,
      DatUkRek: null,
      DatUkZar: null,
      NOK_CustType: null,
      NOK_SalesCode: null,
      ALC_ProductionDate: null,
      ALC_ProductionDate_NUM: null,
      ALC_PuvodniIMEI: null,
      ICS_HWV_In: null,
      APL_FMI: null,
      APL_CiziDistribuce: null,
      APL_Dokumenty: null,
      APL_Neshoda: null,
      ALC_DatUkZar: null,
      TCCM_Urceni: null,
      Predprodej: 0,
      ALL_Zamek: null,
      ALL_ChybiDoklad: null,
      documents: [],
      disagreement: [],
      DeviceDefect1: null,
      DeviceDefect1Ver: null,
      DeviceDefect2: null,
      DeviceDefect2Ver: null,
      DeviceDefect3: null,
      DeviceDefect3Ver: null,
    },
    brtxcard: {
      open: false,
      value: null,
    },
    loading: false,
    alertError: {
      text: "",
      show: false,
    },
  };

  searchByNumAtCard = async (e) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({
        numAtCard: {
          ...this.state.numAtCard,
          loading: true,
          data: [],
          selected: null,
        },
      });
      var _res = await PostApiData({ ...this.props, numAtCard: e });
      if (_res.status === 200) {
        this.setState({
          dataLookup: _res.data,
          searchBy: "API DATA",
          selectedActualApiData: -1,
          numAtCard: {
            ...this.state.numAtCard,
            loading: false,
            data: _res.data,
            searchBy: "API DATA",
          },
        });
      } else {
        this.setState({
          numAtCard: {
            ...this.state.numAtCard,
            loading: false,
            data: [],
            searchBy: "API DATA",
          },
        });
      }
    }, 2000);
  };

  searchByInsuranceNo = async (e) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({
        numAtCard: {
          ...this.state.numAtCard,
          loading: true,
          data: [],
          selected: null,
        },
      });
      var _res = await PostApiData({ ...this.props, insuranceNo: e });
      if (_res.status === 200) {
        this.setState({
          dataLookup: _res.data,
          searchBy: "API DATA",
          selectedActualApiData: -1,
          insuranceNo: {
            ...this.state.insuranceNo,
            loading: false,
            data: _res.data,
            searchBy: "API DATA",
          },
        });
      } else {
        this.setState({
          insuranceNo: {
            ...this.state.insuranceNo,
            loading: false,
            data: [],
            searchBy: "API DATA",
          },
        });
      }
    }, 300);
  };

  searchByImei = async (e) => {
    clearTimeout(this.timer);
    if (e.length < 6) return;
    this.timer = setTimeout(async () => {
      this.setState({
        imei: { ...this.state.imei, loading: true, data: [], selected: null },
        selectedActualApiData: -1,
      });
      var _res = await PostApiData({ ...this.props, deviceSN: e });
      if (_res.status === 200) {
        this.setState({
          dataLookup: _res.data,
          searchBy: "API DATA",
          selectedActualApiData: -1,
          imei: {
            ...this.state.imei,
            loading: false,
            data: _res.data,
            searchBy: "API DATA",
          },
        });
      } 
        }, 300);
  };

  searchByproductCodeSN = async (e) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      this.setState({
        productCodeSN: {
          ...this.state.productCodeSN,
          loading: true,
          data: [],
          selected: null,
        },
      });
      var _res = await PostApiData({ ...this.props, productCodeSN: e });
      if (_res.status === 200) {
        this.setState({
          productCodeSN: {
            ...this.state.productCodeSN,
            loading: false,
            data: _res.data,
            searchBy: "API DATA",
          },
        });
      }
    }, 300);
  };

  async componentDidMount() {
    this.ref = useRef;
    this.setState({
      docno: { ...this.props.docData?.data },
      dataLookup: this.props.apidata ? this.props.apidata : [],
    });
  }

  create = async (prep) => {
    this.setState({
      loading: true,
      alertError: { show: false, text: null },
      brtxcard: { ...this.state.brtxcard, open: false },
    });
    const { setDoc, card, shipDoc, apiset } = this.props;
    let docData = {
      card: card,
      shipDoc: shipDoc,
      doc: { ...this.state.docno, documents: null },
      documents: this.state.docno.documents,
      addDocScan: this.props.addDocScan,
      disagreement: this.state.disagreement,
      rfid: sessionStorage.getItem("RFID"),
      prepare: prep,
      brtxcard: this.state.brtxcard.value,
    };
    var _res = await SetManageDoc({ ...this.props, doc: docData });
    this.setState({
      loading: false,
      alertError: { shshowow: false, text: null },
    });
    if (_res.status === 200) {
      apiset(this.state.selectedActualApiData);
      setDoc();
    } else {
      this.setState({
        loading: false,
        alertError: { show: true, text: _res.data.detail },
      });
      if (_res.data.detail.indexOf("RFID") > -1) this.props.resetRFID();
    }
  };

  RepairTypeToggle = () => {
    const selectEl = this.ref.current;
    if (!selectEl) return;
    selectEl.blur();
  }

  replaceData = (e, idx) => {
    debugger;
    this.setState({
      docno: { ...this.state.docno, ...e },
      selectedActualApiData: idx,
    });
  };

  render() {
    const {
      Bs,
      VARIANT,
      SIZE,
      close,
      repairType,
      vendors,
      processingPriority,
    } = this.props;
    console.log(this.props);
    return (
      <>
        {/* API DATA */}

        {this.state.dataLookup?.length > 0 && (
          <LookUpData
            {...this.props}
            data={this.state.dataLookup}
            searchBy={this.state.searchBy}
            selectedData={this.replaceData}
            selected={this.state.selectedActualApiData}
          />
        )}

        {/* BRTX CARD */}
        <BrtxCardModal
          {...this.props}
          value={this.state.brtxcard.value}
          set={(e) => this.setState(e)}
          sent={() => this.create("1")}
          open={this.state.brtxcard.open}
        />

        <Bs
          modal
          show={true}
          onHide={close}
          keyboard={false}
          backdrop="static"
          centered
          size={SIZE.LG}
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Bs modalheader closeButton>
            {this.state.docno.DocNo > 0 && (
              <Bs span>
                Zakázka č.:
                <Bs strong className="ms-2">
                  {this.state.docno.DocNo}
                </Bs>
              </Bs>
            )}
            {this.state.docno.DocNo < 1 && <Bs span>Vytvořit novou zakázku</Bs>}
          </Bs>
          {this.state.alertError.show && (
            <Bs alert variant={VARIANT.DANGER}>
              <Bs row>
                <Bs col xs={12}>
                  {this.state.alertError.text}
                </Bs>
              </Bs>
            </Bs>
          )}
          <Bs row className="ms-4 me-4">
            <Bs col xs={12} className="mt-4">
              {this.state.loading && (
                <Bs div>
                  <Bs brtxspin className="c-secondary" />
                  <Bs small className="ms-2 text-muted">
                    Načítám data...
                  </Bs>
                </Bs>
              )}
              <Bs row>
                <Bs col xs={12} lg={4}>
                  <Bs formtext>Výrobce</Bs>
                  <Bs
                    brtxselect
                    isDisabled={this.state.loading}
                    placeholder="Vyber výrobce"
                    isClearable
                    options={vendors.filter((f) => f.value > 0)}
                    
                    value={
                      vendors?.filter(
                        (f) =>
                          f.value?.toString() ===
                          this.state.docno?.DeviceFirmCode?.toString()
                      )[0]
                    }
                    onChange={(e) => {
                      document.getElementById("numatcard").focus();
                      this.setState({
                        docno: {
                          ...this.state.docno,
                          DeviceFirmCode: e.value,
                          FirmName: e.label,
                          DeviceType: null,
                        },
                      });
                    }}
                  />
                </Bs>
                <Bs col xs={12} lg={4}>
                  <Bs formtext id="basic-addon1">
                    Zakázka zákazníka
                  </Bs>
                  <Bs
                    formcontrol
                    id="numatcard"
                    value={this.state.docno.NumAtCard}
                    onChange={(e) => {
                      this.searchByNumAtCard(e.target.value);
                      this.setState({
                        docno: {
                          ...this.state.docno,
                          NumAtCard:
                            e.target.value.length === 0 ? null : e.target.value,
                        },
                      });
                    }}
                    onKeyDown= {(e) => {
                      console.log(e);
                      if (e.key === 'Enter') {
                        document.getElementById("devicesn").focus();
                      }
                    }}
                  />
                </Bs>
                <Bs col xs={12} lg={4}>
                  <Bs formtext>IMEI Zařízení</Bs>
                  <Bs
                    formcontrol
                    id="devicesn"
                    value={this.state.docno.DeviceSN}
                    onChange={(e) => {
                      this.searchByImei(e.target.value);
                      this.setState({
                        docno: {
                          ...this.state.docno,
                          DeviceSN: e.target.value,
                        },
                      });
                    }}
                    onKeyDown= {(e) => {
                      if (e.key === 'Enter') {
                        document.getElementById("productcodesn").focus();
                      }
                    }}
                  />
                </Bs>
                <Bs col xs={12} lg={4}>
                  <Bs formtext id="basic-addon1">
                    Sériové číslo
                  </Bs>
                  <Bs
                    formcontrol
                    id="productcodesn"
                    value={this.state.docno.ProductCodeSN}
                    onChange={(e) => {
                      this.searchByproductCodeSN(e.target.value);
                      this.setState({
                        docno: {
                          ...this.state.docno,
                          ProductCodeSN:
                            e.target.value.length === 0 ? null : e.target.value,
                        },
                      });
                    }}
                    onKeyDown= {(e) => {
                      if (e.key === 'Enter') {
                        this.RepairTypeToggle();
                      }
                    }}
                  />
                </Bs>
                <Bs col xs={12} lg={4}>
                  <Bs formtext>Druh opravy</Bs>
                  <Bs
                    brtxselect
                    ref={this.ref}
                    id="devicerepairtype"
                    isDisabled={this.state.loading}
                    value={
                      repairType.filter(
                        (f) => f.value === this.state.docno.DeviceRepairType
                      )[0]
                    }
                    onChange={(e) =>
                      this.setState({
                        docno: {
                          ...this.state.docno,
                          DeviceRepairType: e.value,
                        },
                      })
                    }
                    options={repairType}
                    placeholder="-- Vyber --"
                  />
                </Bs>
                <Bs col xs={12} lg={4}>
                  <Bs formtext>Priorita zpracování</Bs>
                  <Bs
                    brtxselect
                    isDisabled={this.state.loading}
                    value={
                      processingPriority.filter(
                        (f) => f.value === this.state.docno.PrioritaZprac
                      )[0]
                    }
                    onChange={(e) =>
                      this.setState({
                        docno: {
                          ...this.state.docno,
                          PrioritaZprac: e.value,
                        },
                      })
                    }
                    options={processingPriority}
                    placeholder="-- Vyber --"
                  />
                </Bs>
                <Bs col xs={12} lg={4}>
                  <Bs formtext id="basic-addon1">
                    Číslo pojištění
                  </Bs>
                  <Bs
                    formcontrol
                    value={this.state.docno.CisPoj}
                    onChange={(e) => {
                      this.setState({
                        docno: {
                          ...this.state.docno,
                          CisPoj:
                            e.target.value.length === 0 ? null : e.target.value,
                        },
                      });
                    }}
                  />
                </Bs>
                <Bs col xs={12} lg={4}>
                  <Bs formtext>Datum externího příjmu</Bs>
                  <Bs
                    formcontrol
                    type="text"
                    placeholder="den/měsíc/rok"
                    value={this.state.docno.DatExtPr?.split("T")[0]}
                    onChange={(e) =>
                      this.setState({
                        docno: {
                          ...this.state.docno,
                          DatExtPr: e.target.value,
                        },
                      })
                    }
                  />
                </Bs>
                <Bs col xs={12} lg={4}>
                  <Bs formtext>Datum prodeje</Bs>
                  <Bs
                    formcontrol
                    type="text"
                    placeholder="den/měsíc/rok"
                    disabled={this.state.docno.Predprodej === 1 ? true : false}
                    value={this.state.docno.DatProdej?.split("T")[0]}
                    onChange={(e) => {
                      this.setState({
                        docno: {
                          ...this.state.docno,
                          DatProdej: e.target.value,
                        },
                      });
                    }}
                  />
                </Bs>
                <Bs col xs={12} lg={4}>
                  <Bs formtext>Předprodejní reklamace</Bs>
                  <Bs
                    formswitch
                    checked={this.state.docno.Predprodej === 1 ? true : false}
                    onChange={(e) =>
                      this.setState({
                        docno: {
                          ...this.state.docno,
                          Predprodej: e.target.checked ? 1 : 0,
                          DatProdej: null,
                        },
                      })
                    }
                  />
                </Bs>
                
              </Bs>
            </Bs>
          </Bs>
          <Bs modalfooter className="mt-4">
            <Bs row>
              <Bs
                col
                className={
                  this.state.docno.DocNo > 0
                    ? "d-flex justify-content-between"
                    : "d-flex justify-content-end"
                }
              >
                <Bs
                  button
                  variant={VARIANT.SUCCESS}
                  size={SIZE.SM}
                  onClick={() =>
                    this.setState({
                      brtxcard: { ...this.state.brtxcard, open: true },
                    })
                  }
                  disabled={this.state.loading}
                >
                  {this.state.loading ? (
                    <Bs brtxspin />
                  ) : this.state.docno.DocNo <= 0 ? (
                    "Předpříjem"
                  ) : (
                    "Upravit zakázku"
                  )}
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        </Bs>
      </>
    );
  }
}

export default Unpacking;
